import React from "react";
import {
  FaShieldAlt,
  FaUserLock,
  FaCheckCircle,
  FaDatabase,
  FaShareAlt,
  FaLock,
  FaUserCheck,
  FaEnvelope,
} from "react-icons/fa";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        background: "linear-gradient(135deg, #F5F5F5 0%, #FFFFFF 100%)",
        minHeight: "100vh",
        paddingBottom: "40px",
      }}
    >
      {/* Enhanced Header */}
      <header
        style={{
          background: "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
          color: "#fff",
          padding: "50px 20px 35px 20px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative Circles */}
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-30px",
            left: "-30px",
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 1,
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              background: "rgba(255, 255, 255, 0.2)",
              padding: "6px 16px",
              borderRadius: "20px",
              marginBottom: "16px",
              fontSize: "0.85rem",
              fontWeight: "600",
            }}
          >
            <FaShieldAlt style={{ fontSize: "0.9rem" }} />
            Trivana Hospitality
          </div>

          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              marginBottom: "12px",
              letterSpacing: "-0.8px",
              textShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            Privacy Policy
          </h1>

          <p
            style={{
              fontSize: "1rem",
              opacity: 0.95,
              fontWeight: "500",
              maxWidth: "700px",
              margin: "0 auto 12px auto",
              lineHeight: "1.6",
            }}
          >
            Your privacy is our priority. At Trivana Hospitality, we are
            committed to protecting your personal information and being
            transparent about our practices.
          </p>

          <div
            style={{
              fontSize: "0.85rem",
              opacity: 0.9,
              fontWeight: "500",
            }}
          >
            Effective date: September 5, 2025
          </div>
        </div>
      </header>

      <div style={{ maxWidth: "1000px", margin: "0 auto", padding: "0 20px" }}>
        {/* Table of Contents */}
        <nav
          style={{
            background: "#FFFFFF",
            padding: "24px",
            borderRadius: "14px",
            margin: "35px 0",
            border: "1px solid rgba(238, 46, 36, 0.1)",
            boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
          }}
        >
          <h2
            style={{
              fontSize: "1.1rem",
              fontWeight: "800",
              color: "#2E2E2E",
              marginBottom: "16px",
              letterSpacing: "-0.5px",
            }}
          >
            Table of Contents
          </h2>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "10px",
            }}
          >
            {[
              { id: "introduction", title: "1. Introduction" },
              { id: "information-collect", title: "2. Information We Collect" },
              { id: "how-we-use", title: "3. How We Use Your Information" },
              { id: "information-sharing", title: "4. Information Sharing" },
              { id: "data-security", title: "5. Data Security" },
              { id: "data-retention", title: "6. Data Retention" },
              { id: "your-rights", title: "7. Your Rights" },
              { id: "cookies", title: "8. Cookies & Tracking" },
              { id: "third-party", title: "9. Third-Party Links" },
              { id: "children-privacy", title: "10. Children's Privacy" },
              { id: "changes", title: "11. Policy Changes" },
              { id: "contact", title: "12. Contact Us" },
            ].map((item, index) => (
              <li key={index}>
                <a
                  href={`#${item.id}`}
                  style={{
                    color: "#2E2E2E",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, rgba(238, 46, 36, 0.08) 0%, rgba(255, 196, 0, 0.08) 100%)";
                    e.target.style.transform = "translateX(5px)";
                    e.target.style.color = "#EE2E24";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "transparent";
                    e.target.style.transform = "translateX(0)";
                    e.target.style.color = "#2E2E2E";
                  }}
                >
                  <FaCheckCircle
                    style={{ fontSize: "0.75rem", color: "#EE2E24" }}
                  />
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* --- Sections --- */}
        <section
          id="introduction"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">1. Introduction</h2>
          </div>
          <p className="text-dark text-start">
            This Privacy Policy explains how Trivana Hospitality ("we", "us",
            "our") collects, uses, shares, and protects your personal
            information when you use Booktrivana (the "Website") or our
            services. By using our Website or services, you agree to the
            collection and use of information in accordance with this policy.
            Please also review our{" "}
            <strong>
              <a href="/terms-conditions" className="contact-link">
                Terms &amp; Conditions
              </a>
            </strong>
            .
          </p>
        </section>

        <section
          id="information-collect"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              2. Information We Collect
            </h2>
          </div>
          <p className="text-dark text-start">
            We collect information to operate our services effectively and
            securely. This may include:
          </p>
          <ul className="mt-2 text-dark text-start">
            <li>
              <strong>Personal Information:</strong> Name, email address, phone
              number, postal address, payment information, and other data you
              provide during bookings, account creation, or job applications.
            </li>
            <li>
              <strong>Usage Data:</strong> Information about how you interact
              with our Website (e.g., IP address, browser type, pages visited,
              time spent on pages).
            </li>
            <li>
              <strong>Transactional Data:</strong> Details related to your
              payments and reservations, processed securely through third-party
              payment gateways.
            </li>
            <li>
              <strong>Cookies &amp; Tracking Technologies:</strong> Data
              collected via cookies and similar technologies to enhance user
              experience and analyze usage patterns.
            </li>
          </ul>
        </section>

        <section
          id="how-we-use"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              3. How We Use Your Information
            </h2>
          </div>
          <p className="text-dark text-start">
            We use the information we collect for the following purposes:
          </p>
          <div className="row mt-3 g-3">
            <div className="col-12 col-lg-6">
              <h5 className="fw-bold text-dark text-start">
                Service Provision
              </h5>
              <p className="mt-2 text-dark text-start">
                To process bookings, manage your account, and communicate with
                you about your reservations.
              </p>
            </div>
            <div className="col-12 col-lg-6">
              <h5 className="fw-bold text-dark text-start">Customer Support</h5>
              <p className="mt-2 text-dark text-start">
                To respond to your inquiries, provide support, and improve our
                services based on your feedback.
              </p>
            </div>
            <div className="col-12 col-lg-6">
              <h5 className="fw-bold text-dark text-start">
                Marketing &amp; Communications
              </h5>
              <p className="mt-2 text-dark text-start">
                To send you promotional offers, newsletters, and updates about
                our services (with your consent where required).
              </p>
            </div>
            <div className="col-12 col-lg-6">
              <h5 className="fw-bold text-dark text-start">
                Security &amp; Fraud Prevention
              </h5>
              <p className="mt-2 text-dark text-start">
                To protect against unauthorized access, fraud, and other illegal
                activities.
              </p>
            </div>
          </div>
        </section>

        <section
          id="information-sharing"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              4. Information Sharing
            </h2>
          </div>
          <p className="text-dark text-start">
            We only share your data with your consent or when necessary to
            fulfill a service. This includes:
          </p>
          <ul className="mt-2 text-dark text-start">
            <li>
              <strong>Service Providers:</strong> Hotels, restaurants, and other
              third-party providers necessary to complete your bookings.
            </li>
            <li>
              <strong>Payment Processors:</strong> Secure third-party payment
              gateways to process transactions.
            </li>
            <li>
              <strong>Legal Requirements:</strong> When required by law,
              regulation, or legal process.
            </li>
            <li>
              <strong>Business Transfers:</strong> In the event of a merger,
              acquisition, or sale of assets, your information may be
              transferred to the new entity.
            </li>
          </ul>
          <p className="mt-2 text-dark text-start">
            We do not sell your personal information to third parties for
            marketing purposes.
          </p>
        </section>

        <section
          id="data-security"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">5. Data Security</h2>
          </div>
          <p className="text-dark text-start">
            We employ industry-standard security measures to protect your
            personal information, including encryption, secure servers, and
            access controls. We continuously update our protocols to maintain
            the highest level of protection possible. However, no security
            system is completely without risk, and we cannot guarantee absolute
            security.
          </p>
        </section>

        <section
          id="data-retention"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">6. Data Retention</h2>
          </div>
          <p className="text-dark text-start">
            We retain your personal information for as long as necessary to
            fulfill the purposes outlined in this Privacy Policy, comply with
            legal obligations, resolve disputes, and enforce our agreements.
            When your information is no longer needed, we will securely delete
            or anonymize it.
          </p>
        </section>

        <section
          id="your-rights"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">7. Your Rights</h2>
          </div>
          <p className="text-dark text-start">
            You have the right to access, update, and request the deletion of
            your personal information at any time. You may also:
          </p>
          <ul className="mt-2 text-dark text-start">
            <li>
              <strong>Access:</strong> Request a copy of the personal
              information we hold about you.
            </li>
            <li>
              <strong>Correction:</strong> Request correction of inaccurate or
              incomplete information.
            </li>
            <li>
              <strong>Deletion:</strong> Request deletion of your personal
              information, subject to legal and contractual obligations.
            </li>
            <li>
              <strong>Opt-Out:</strong> Unsubscribe from marketing
              communications at any time by clicking the unsubscribe link in our
              emails.
            </li>
            <li>
              <strong>Data Portability:</strong> Request a copy of your data in
              a structured, commonly used format.
            </li>
          </ul>
          <p className="mt-2 text-dark text-start">
            To exercise these rights, please contact us at{" "}
            <a className="contact-link" href="mailto:booktrivana@gmail.com">
              booktrivana@gmail.com
            </a>
            .
          </p>
        </section>

        <section id="cookies" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              8. Cookies &amp; Tracking Technologies
            </h2>
          </div>
          <p className="text-dark text-start">
            We use cookies and similar tracking technologies to enhance your
            browsing experience, analyze site traffic, and understand user
            behavior. Cookies are small text files stored on your device. You
            can control cookie settings through your browser, but disabling
            cookies may limit certain features of our Website.
          </p>
        </section>

        <section
          id="third-party"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">9. Third-Party Links</h2>
          </div>
          <p className="text-dark text-start">
            Our Website may contain links to third-party websites or services.
            We are not responsible for the privacy practices or content of these
            external sites. We encourage you to review the privacy policies of
            any third-party sites you visit.
          </p>
        </section>

        <section
          id="children-privacy"
          className="card p-4 mb-4 shadow-sm animate-fade"
        >
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              10. Children's Privacy
            </h2>
          </div>
          <p className="text-dark text-start">
            Our services are not intended for children under the age of 18. We
            do not knowingly collect personal information from children. If we
            become aware that we have collected information from a child without
            parental consent, we will take steps to delete that information.
          </p>
        </section>

        <section id="changes" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">
              11. Changes to This Privacy Policy
            </h2>
          </div>
          <p className="text-dark text-start">
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or legal requirements. We will post the
            updated policy on this page with a revised effective date. Continued
            use of our services after changes constitutes acceptance of the
            updated policy.
          </p>
        </section>

        <section id="contact" className="card p-4 mb-4 shadow-sm animate-fade">
          <div className="d-flex align-items-center mb-2">
            <span className="section-accent me-3"></span>
            <h2 className="card-title h4 mb-0 fw-bold">12. Contact Us</h2>
          </div>
          <p className="text-dark text-start">
            For any questions or concerns about this Privacy Policy or our data
            practices, please contact our support team:
          </p>
          <p className="mt-2 text-dark text-start">
            <strong>Trivana Hospitality (Booktrivana)</strong>
            <br />
            Email:{" "}
            <a className="contact-link" href="mailto:booktrivana@gmail.com">
              booktrivana@gmail.com
            </a>
            <br />
            Phone: +91 9257734350 (support hours apply)
          </p>

          <p className="mt-3 text-muted text-start">
            Note: We are committed to protecting your privacy and handling your
            data responsibly. Thank you for trusting Trivana Hospitality with
            your information.
          </p>
        </section>
      </div>

      {/* Custom CSS for features not in Bootstrap */}
      <style>{`
        /* Global & overflow fixes (RESPO PROBLEM safe) */
        html,
        body {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: "Inter", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          overflow-x: hidden;
          scroll-behavior: smooth;
        }

        *,
        *::before,
        *::after {
          box-sizing: inherit;
        }

        /* Page wrapper & background */
        .privacy-wrapper {
          min-height: 100vh;
          width: 100%;
          background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
          overflow-x: hidden;
        }

        /* Animated gradient heading (Trivana theme) */
        .header-title {
          font-size: clamp(22px, 3.4vw, 40px);
          font-weight: 800;
          line-height: 1.05;
          margin: 0 0 8px 0;
          background: linear-gradient(90deg, #EE2E24, #FFC400, #EE2E24);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          display: inline-block;
          animation: slideInFromTop 600ms ease both;
        }

        .subhead {
          color: #475569;
          font-size: clamp(14px, 1.6vw, 18px);
          margin: 0 auto;
          max-width: 900px;
        }
        
        /* Card hover animation */
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 40px rgba(14, 30, 37, 0.08);
        }

        /* Section headings inside cards */
        .section-accent {
          width: 6px;
          height: 26px;
          border-radius: 4px;
          background: linear-gradient(180deg, #EE2E24, #FFC400);
          flex-shrink: 0;
        }
        
        /* Table of contents and contact links */
        .toc-link,
        .contact-link {
          color: #0f172a; /* Default link color */
          font-weight: 600;
          text-decoration: none;
          transition: color 0.2s ease;
        }
        
        .toc-link:hover,
        .contact-link:hover {
          color: #EE2E24; /* Brand hover color */
          text-decoration: underline;
        }

        /* small utilities and responsive fixes */
        .muted {
          color: #6b7280;
        }

        /* anchor offset for sticky headers if any */
        :target {
          scroll-margin-top: 90px;
        }

        /* Animations */
        @keyframes slideInFromTop {
          from {
            opacity: 0;
            transform: translateY(-12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade {
          animation: fadeUp 600ms ease both;
        }
        `}</style>
    </div>
  );
};

export default PrivacyPolicy;
